const SECTION_ANCHORS = [
  '#',
  'projects',
  'online-purchase',
  'pik-children',
  'about',
  'furniture',
  'offices',
  'smart-home',
  'seria-plus',
] as const;

export const DATA_AS_NAV_TAB_ATTR = 'data-as-nav-tab';

export type TSectionAnchor = (typeof SECTION_ANCHORS)[number];

export function isSectionAnchor(value: string): value is TSectionAnchor {
  return SECTION_ANCHORS.some(anchor => anchor === value);
}

export interface INavLinks {
  title: string;
  value: TSectionAnchor;
  offsetTop: number;
  offsetHeight: number;
}
